import React from "react";
import css from "./style.module.css";
import { FormattedMessage } from "react-intl";

const ChangedInfo = props => {
  const { createdByName, createdAt, updatedByName, updatedAt } = props.value;

  return (
    <div className={css.box}>
      <div>
        <div>
          <FormattedMessage id="GENERAL.LABEL.CREATED" />:
        </div>
        <div>
          <FormattedMessage id="GENERAL.LABEL.UPDATED" />:{" "}
        </div>
      </div>
      <div>
        <div>{createdByName}</div>
        <div>{updatedByName}</div>
      </div>
      <> </>
      <div>
        <div>{createdAt}</div>
        <div>{updatedAt}</div>
      </div>
    </div>
  );
};

export default ChangedInfo;
